import { Component } from "@angular/core";
import { BaseTimelineFilterComponent } from "../../base/timeline-filter/base-timeline-filter.component";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  selector: "app-collections-timeline-filter",
  templateUrl: "./collection-timeline-filter.component.html",
  styleUrls: ["../../base/timeline-filter/base-timeline-filter.component.scss"],
  standalone: false,
})
export class CollectionTimelineFilterComponent extends BaseTimelineFilterComponent {
  constructor(googleAnalyticsService: GoogleAnalyticsService) {
    super(googleAnalyticsService);
  }

  /**
   * Use filters to send to parent controller and handle projects(aoi) visibility
   */
  applyFilters(emmit: boolean = true) {
    if (emmit) {
      const event = {
        filters: this.filters,
        projects: null,
      };

      this.onUpdateProjects.emit(event);
    }
  }
}
